var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getName } from "../../redux/contact/contact.utils";
import { getValue } from "../../redux/form/form.utils";
import { EContractMemberTypes, EContractPaymentRepetitionType, EInsuranceExternalStatus, } from "../../types/contract.types";
import { ELocale } from "../../types/i18n.types";
import { EPropertyMemberTypes, EPropertyTypeId, } from "../../types/property.types";
import { ERentDepositProvider } from "../../types/rentDeposit.types";
import { formatDate } from "../../utils/date.utils";
import { getLocale, getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getStore } from "../../utils/redux/redux.utils";
import { getMembersWithOneOfRoles } from "../../utils/roles.utils";
import { EField } from "./schema.createRentDeposit.types";
import { customGetForeignerContactsForAccountIds } from "./schema.createRentDeposit.utils.fetchContracts";
var NOW = new Date();
export var getNavigationTitle = function (_) {
    return getLocalizedText("new.rent_deposit.contract");
};
export var getMonthlyPrice = function (contract) {
    switch (contract.repetitionType) {
        case EContractPaymentRepetitionType.Yearly:
            return contract.currentPrice / 12;
        case EContractPaymentRepetitionType.Quarterly:
            return contract.currentPrice / 3;
        default:
            return contract.currentPrice;
    }
};
export var getInitialValues = function (extraData) {
    var _a;
    var contract = extraData.contract;
    // Only support for NL & FR contracts
    var locale = ELocale.NL;
    if (getLocale() === ELocale.FR) {
        locale = ELocale.FR;
    }
    var getDefaultTenantSigner = function () {
        var _a;
        var tenants = extraData.contract.members
            .filter(function (member) {
            return member.roles.some(function (role) {
                return [
                    EContractMemberTypes.Tenant,
                    EContractMemberTypes.Parent,
                ].includes(role);
            });
        })
            .map(function (member) { return member.account; });
        if (tenants.length === 1) {
            return [(_a = tenants[0]) === null || _a === void 0 ? void 0 : _a.id];
        }
        return [];
    };
    return _a = {},
        _a[EField.StartDate] = contract.startDate,
        _a[EField.TenantSigners] = getDefaultTenantSigner(),
        _a[EField.DueDate] = NOW,
        _a[EField.Amount] = contract.rentDepositAmount,
        _a[EField.Locale] = locale,
        _a[EField.MPLocale] = locale,
        _a;
};
export var getMergedMembers = function (contract, property) {
    return __spreadArray(__spreadArray([], contract.members.filter(function (member) {
        return member.roles.some(function (role) {
            return [
                EContractMemberTypes.Owner,
                EContractMemberTypes.Tenant,
                EContractMemberTypes.Parent,
            ].includes(role);
        });
    }), true), property.members.filter(function (member) {
        return member.roles.includes(EPropertyMemberTypes.FinancialManager);
    }), true);
};
export var getForeigners = function (accountIds) {
    var _a;
    try {
        if (!accountIds) {
            return;
        }
        var state = (_a = getStore()) === null || _a === void 0 ? void 0 : _a.getState();
        if (!state) {
            return;
        }
        return customGetForeignerContactsForAccountIds(state, accountIds);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
export var getOwners = function (formData, extraData) {
    var contract = extraData.contract;
    return getMembersWithOneOfRoles(contract.members, [
        EContractMemberTypes.Owner,
    ])
        .filter(function (member) {
        return (formData[EField.Signers] || []).includes(member.account.id);
    })
        .map(function (member) { return member.account; });
};
export var getTenants = function (formData, extraData) {
    var contract = extraData.contract;
    return getMembersWithOneOfRoles(contract.members, [
        EContractMemberTypes.Tenant,
        EContractMemberTypes.Parent,
    ])
        .filter(function (member) {
        return (formData[EField.Signers] ||
            formData[EField.TenantSigners] ||
            []).includes(member.account.id);
    })
        .map(function (member) { return member.account; });
};
export var showInsurance = function (extraData) {
    var contract = extraData.contract, withInsuranceRequest = extraData.withInsuranceRequest, property = extraData.property;
    return Boolean(contract.insuranceExternalStatus === EInsuranceExternalStatus.None &&
        withInsuranceRequest &&
        property.typeId &&
        [EPropertyTypeId.Apartment, EPropertyTypeId.House].includes(property.typeId));
};
export var getIsProviderBanqup = function (value) {
    return ERentDepositProvider.Banqup === value;
};
export var getIsShowMangopaySignersForm = function (formData, extraData) {
    if (extraData.showProviderOptions) {
        return formData[EField.Provider] === ERentDepositProvider.MangoPay;
    }
    if (extraData.hasBanqupEnabled) {
        return false;
    }
    return true;
};
export var getIsShowBanqupSignersForm = function (formData, extraData) {
    if (extraData.showProviderOptions) {
        return formData[EField.Provider] === ERentDepositProvider.Banqup;
    }
    if (extraData.hasBanqupEnabled) {
        return true;
    }
    return false;
};
export var getIsShowMangopayIDForm = function (formData, extraData) {
    var foreigners = getForeigners(formData[EField.Signers]) || [];
    if (extraData.showProviderOptions) {
        return (formData[EField.Provider] === ERentDepositProvider.MangoPay &&
            foreigners.length > 0);
    }
    if (extraData.hasBanqupEnabled) {
        return false;
    }
    return foreigners.length > 0;
};
export var getIsShowBanqupIDForm = function (formData, extraData) {
    if (extraData.showProviderOptions) {
        return formData[EField.Provider] === ERentDepositProvider.Banqup;
    }
    if (extraData.hasBanqupEnabled) {
        return true;
    }
    return false;
};
export var getIdDocumentsSummary = function (docs) {
    if (docs === void 0) { docs = []; }
    if (!Array.isArray(docs) || docs.length === 0)
        return "";
    var docTypeLabel = getLocalizedText("rent_deposit.documentType.label");
    var dateOfExpiryLabel = getLocalizedText("rent_deposit.id_expiry_date.label");
    var dateOfIssuanceLabel = getLocalizedText("rent_deposit.date_of_issuance.label");
    var countryOfIssuanceLabel = getLocalizedText("rent_deposit.country_of_issuance.label");
    var documentNumberLabel = getLocalizedText("rent_deposit.document_number.label");
    return docs
        .map(function (doc) {
        if (!doc)
            return null;
        var contactName = doc.contact
            ? getName(doc.contact)
            : getLocalizedText("rent_deposit.no_contact");
        var docType = doc.documentType
            ? getLocalizedText("rent_deposit.documentType.".concat(doc.documentType.toLowerCase()))
            : undefined;
        if (!docType) {
            return contactName;
        }
        var expiry = doc.dateOfExpiry
            ? formatDate(doc.dateOfExpiry)
            : getLocalizedText("rent_deposit.not_provided");
        var issuance = doc.dateOfIssuance
            ? formatDate(doc.dateOfIssuance)
            : getLocalizedText("rent_deposit.not_provided");
        var country = doc.countryOfIssuance || getLocalizedText("rent_deposit.not_provided");
        var number = doc.documentNumber || getLocalizedText("rent_deposit.not_provided");
        return [
            "".concat(contactName),
            "".concat(docTypeLabel, ": ").concat(docType),
            "".concat(dateOfExpiryLabel, ": ").concat(expiry),
            "".concat(dateOfIssuanceLabel, ": ").concat(issuance),
            "".concat(countryOfIssuanceLabel, ": ").concat(country),
            "".concat(documentNumberLabel, ": ").concat(number),
        ].join(" | ");
    })
        .filter(Boolean)
        .join(", ");
};
export var getPayerForBanqup = function (defaultValues, extraData) {
    var _a;
    var tenants = getTenants(defaultValues, extraData) || [];
    var payer = tenants.length > 1
        ? defaultValues[EField.Payer]
        : [(_a = tenants[0]) === null || _a === void 0 ? void 0 : _a.id];
    return tenants.find(function (tenant) { return (tenant === null || tenant === void 0 ? void 0 : tenant.id) === payer[0]; });
};
export var getForeignersForBanqup = function (initialValues, defaultValues, extraData) {
    var selectedPayer = getPayerForBanqup(defaultValues, extraData);
    // const owners = extraData.contract.members
    //   .filter(member =>
    //     member.roles.some(role => role === EContractMemberTypes.Owner),
    //   )
    //   .map((member: any) => member.account);
    // const foreignOwners = getForeigners(owners.map(owner => owner.id)) || [];
    var foreignTenants = getForeigners(getValue(EField.TenantSigners, initialValues, defaultValues)) || [];
    var foreigners = __spreadArray([], foreignTenants, true);
    if (foreigners.length > 0) {
        return foreigners
            .filter(function (contact) { return contact.accountId !== (selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.id); })
            .map(function (contact) {
            var _a;
            return (_a = {},
                _a[EField.IdentityDocumentAccountId] = contact.accountId,
                _a.contact = contact,
                _a);
        });
    }
    return [];
};
export var isFileSizeValid = function (file, maxMB) {
    var maxSizeInBytes = maxMB * 1024 * 1024;
    return file.size <= maxSizeInBytes;
};
